import { baseApi } from "./base.api";

export const smtpConfigApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchLatestSmtpConfig: build.query({
      query: () => ({ url: "/smtp-config/fetch/latest", method: "GET" }),
      providesTags: ["SmtpConfig"],
    }),
    saveSmtpConfig: build.mutation({
      query: (body) => ({ url: "/smtp-config/save", method: "POST", body }),
      invalidatesTags: ["SmtpConfig"],
    }),
  }),
});

export const {
  useFetchLatestSmtpConfigQuery,
  useSaveSmtpConfigMutation,
} = smtpConfigApi;
